// Canonical NearNow trade categories.
// Used by:
//   - Homeowner search (homepage waitlist + future /book flow)
//   - Contractor onboarding (signup trade selector)
//   - SEO micro-page slug generation
//   - ARIA voice agent intake question routing

export const TRADES = [
  { code: "hvac",         label: "HVAC",          rank: 1 },
  { code: "roofing",      label: "Roofing",       rank: 2 },
  { code: "plumbing",     label: "Plumbing",      rank: 3 },
  { code: "electrical",   label: "Electrical",    rank: 4 },
  { code: "remodeling",   label: "Remodeling",    rank: 5 },
  { code: "landscaping",  label: "Landscaping",   rank: 6 },
  { code: "cleaning",     label: "Cleaning",      rank: 7 },
  { code: "handyman",     label: "Handyman",      rank: 8 },
  { code: "pest_control", label: "Pest Control",  rank: 9 },
  { code: "tree_services", label: "Tree Services", rank: 10 },
  { code: "painting",     label: "Painting",      rank: 11 },
  { code: "solar",        label: "Solar",         rank: 12 },
  { code: "ev_charging",  label: "EV Charging",   rank: 13 },
  { code: "sewer_drain",  label: "Sewer and Drain", rank: 14 },
];

// Convenience exports
export const TRADE_CODES = TRADES.map((t) => t.code);
export const TRADE_LABELS = TRADES.map((t) => t.label);
export const TRADE_BY_CODE = Object.fromEntries(TRADES.map((t) => [t.code, t]));
